export const APPLICATION_CODES = [
  'admin',
  'main',
  'learn',
  'invoice',
  'pos',
  'pharma',
  'member',
] as const

export type ApplicationCode = (typeof APPLICATION_CODES)[number]

export const DEFAULT_ADMIN_APPLICATION_CODE: ApplicationCode = 'admin'

export const APPLICATION_OPTIONS: Array<{ code: ApplicationCode; label: string }> = [
  { code: 'admin', label: 'BORAsuite Admin' },
  { code: 'main', label: 'BORAsuite Web' },
  { code: 'learn', label: 'BORAlearn' },
  { code: 'invoice', label: 'BORAinvoice' },
  { code: 'pos', label: 'BORApos' },
  { code: 'pharma', label: 'BORApharma' },
  { code: 'member', label: 'BORAmembers' },
]

export function isApplicationCode(value: unknown): value is ApplicationCode {
  return typeof value === 'string' && APPLICATION_CODES.includes(value as ApplicationCode)
}

export function getApplicationLabel(code: string | null | undefined): string {
  if (!code) return 'Unknown App'
  return APPLICATION_OPTIONS.find((item) => item.code === code)?.label || code.toUpperCase()
}
